<template>
    <flex-container
        class="expandable-button"
        :gap="null"
    >
        <button-block
            :disabled="props.buttonDisabled"
            :color="props.color"
            @loading="emit('click', $event)"
        >
            <slot />
        </button-block>

        <button-collapse
            :disabled="props.collapseDisabled"
            :color="props.color"
            :options="props.options"
            :horizontal-position="props.horizontalPosition"
            :vertical-position="props.verticalPosition"
            @click="emit('collapse-click', $event)"
        />
    </flex-container>
</template>

<script setup lang="ts">
    import {
        ButtonCollapse,
        type ButtonStateChangedEvent,
        type CollapseHorizontalPosition,
        type CollapseVerticalPosition,
    } from '@keyvue/one-ui';

    interface Props {
        buttonDisabled?: boolean;
        collapseDisabled?: boolean;
        horizontalPosition?: CollapseHorizontalPosition
        verticalPosition?: CollapseVerticalPosition
        color?: string;
        options: Array<{
            value: string;
            label: string;
        }>;
    }

    const props = withDefaults(defineProps<Props>(), {
        buttonDisabled: false,
        collapseDisabled: false,
        horizontalPosition: 'right',
        verticalPosition: 'top-out',
        color: 'primary',
    });

    const emit = defineEmits<{
        (e: 'click', event: ButtonStateChangedEvent): void;
        (e: 'collapse-click', event: string): void;
    }>();

</script>

<style scoped lang="scss">
    .expandable-button {
        gap: 1px;

        :deep(.button-block) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        :deep(.button-collapse) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
</style>
